import React, { useEffect, useReducer } from 'react';
import HeaderModules from '../HeaderModules';
import { TuneOutlined } from '@material-ui/icons';
import { fb } from '../../utils/Firebase';
import { settingsReducer } from '../../reducers/settingsReducer';
import VideoForm from './VideoForm';
import { ListsForm } from './ListsForm';

const initialState = {};

const SettingsScreen = props => {

    const { setIsReady } = props;

    const [state, dispatch] = useReducer(settingsReducer, initialState);

    useEffect(() => {
        let subscribed = true;

        (async () => {
            if(subscribed) {
                const response = await fb.firestore().collection('configuraciones').doc('principal').get();
                dispatch({ type: 'add', payload: response.data() });
                setIsReady(true);
            }
        })();
        return () => subscribed = false;
    }, []);

    return (
        <>
            <HeaderModules 
                icon={<TuneOutlined htmlColor='rgba(0,0,0, .7)' />} 
                title='Configuraciones' 
            />

            { state.video && <VideoForm state={state} /> }

            {/* <ListsForm /> */}
        </>
    );
}

export default SettingsScreen;